module.exports = new __parcel__URL__("masterofbattle.66a48892.png").toString();